import React from 'react';

const UnsupportedMessage = () => <div className='chatterbox-unsupported'>Unsupported message content.</div>;

export default UnsupportedMessage;
